import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import { Form, Input, Button, Row, Col, Select, TreeSelect, message, Table, Typography } from 'antd';
import { inventorySupplierSales, inventoryAddList, inventoryAddOftenList } from '../api';
import './cartForm.less';

const { Option } = Select;
const layout = { labelCol: { span: 10, }, wrapperCol: { span: 14, }, };
const columns = [
  { title: '商品图片', key: 'sale_image', dataIndex: 'sale_image', align: 'center', render: text => <img className='proposal-cart-table-product-img' src={text} alt='' /> },
  {
    title: '商品名称', key: 'goods_name', dataIndex: 'goods_name', align: 'center', render: (text, record) => {
      const { false_reason, add_cart } = record;
      return <><div>{text}</div><div><Typography.Link>{add_cart ? null : false_reason}</Typography.Link></div></>;
    }
  },
  { title: '供应商', key: 'supplier_name', dataIndex: 'supplier_name', align: 'center', },
  { title: '单价', key: 'norms_price', dataIndex: 'norms_price', align: 'center', },
  { title: '商品单位', key: 'unit_name', dataIndex: 'unit_name', align: 'center', },
  { title: 'SKU编码', key: 'in_sku_no', dataIndex: 'in_sku_no', align: 'center', },
  { title: '商品分类', key: 'category_list', dataIndex: 'category_list', align: 'center', },
  { title: '品牌', key: 'brand_name', dataIndex: 'brand_name', align: 'center', },
];
export const CartProduct = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({ form }));
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);
  const [pageConfig, setPageConfig] = useState({ page: 1, page_size: 10 });
  const [selectItems, setSelectItems] = useState({ selectedRowKeys: [], selectedRows: [] });
  const [totalPage, setTotalPage] = useState(1);
  async function getInventorySupplierSales() {
    const { often_id } = props;
    setSelectItems({ selectedRowKeys: [], selectedRows: [] });
    const formValues = form.getFieldsValue() || {};
    const { brand_id: brandId } = formValues;
    const brand_id = brandId ? [brandId] : brandId;
    const { data: { code, msg, data } } = await inventorySupplierSales({ ...formValues, brand_id, ...pageConfig, often_id });
    if (+code === 0) {
      const { list = [], total } = data;
      setDataSource(list);
      setTotalPage(total);
    } else {
      message.error(msg);
    }
  }
  useEffect(() => {
    getInventorySupplierSales();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageConfig]);
  const onFinish = () => {
    // getInventorySupplierSales();
    setPageConfig({ ...pageConfig, page: 1 });
  };
  const onReset = () => {
    form.resetFields();
    setPageConfig({ ...pageConfig, page: 1 });
    // getInventorySupplierSales();
  };

  const tablePageChange = (page, pageSize) => {
    setSelectItems({ selectedRowKeys: [], selectedRows: [] });
    setPageConfig({ ...pageConfig, page });
  };
  const rowSelection = {
    selectedRowKeys: selectItems.selectedRowKeys || [],
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectItems({ selectedRowKeys, selectedRows });
    },
    getCheckboxProps: (record) => ({
      disabled: !record.add_cart,
    }),
  };
  const addToCart = async () => {
    const { type, often_id } = props;
    const { selectedRows = [] } = selectItems;
    const result = {
      cart: async () => inventoryAddList({ data: selectedRows }),
      often: async () => inventoryAddOftenList({ data: selectedRows, id: often_id }),
    };
    const { data: { code, msg } } = await result[type]() || {};
    if (+code === 0) {
      message.success(msg);
      props.refresh();
    } else {
      message.error(msg);
    }
  };
  return (
    <div className='cart-form'  style={{ minHeight: 500 }}>
      <Form className='cart-form-search' size='small' form={form} name="cartForm"  {...layout} onFinish={onFinish}>
        <Row>
          <Col span={8}><Form.Item name="sku_no" label='SKU编码' className='cart-form-label'><Input placeholder="" /></Form.Item></Col>
          <Col span={8}><Form.Item name="sku_name" label='商品名称' className='cart-form-label'><Input placeholder="" /></Form.Item></Col>
          <Col span={8}><Form.Item name="bar_code" label='SKU条码(UPC码)' className='cart-form-label'><Input placeholder="" /></Form.Item></Col>
          <Col span={8}><Form.Item name="supplier_id" label='供应商：' className='cart-form-label'><Select placeholder="">{(props?.suppliersList || []).map(item => <Option value={item.company_id} key={item.company_id} >{item.company.name}</Option>)}</Select></Form.Item></Col>
          <Col span={8}>
            <Form.Item name="category_id" label='商品分类：' className='cart-form-label'>
              <TreeSelect
                treeData={(props?.categoryList || [])}
                maxTagCount={2}
                showSearch
                style={{ width: '100%', }}
                treeDataSimpleMode
                fieldNames={{ label: 'name', value: 'id', children: 'children' }}
                dropdownStyle={{ maxHeight: 200, overflow: 'auto', }}
                placeholder=""
                allowClear
                multiple
                filterTreeNode={(inputValue, treeNode) => treeNode.name.includes(inputValue)}
                treeDefaultExpandAll
              ></TreeSelect>
            </Form.Item>
          </Col>
          <Col span={8}><Form.Item name="brand_id" label='品牌：' className='cart-form-label'><Select placeholder="">{(props?.brandList || []).map(item => <Option value={item.id} key={item.id}>{item.name}</Option>)}</Select></Form.Item></Col>
          <Col span={8} offset={16} style={{ textAlign: 'right' }}><Button type='primary' htmlType='submit'>搜索</Button><Button style={{ marginLeft: 8 }} onClick={onReset}>重置</Button><Button disabled={!selectItems.selectedRowKeys.length} style={{ marginLeft: 8 }} onClick={addToCart} type='primary'>确认添加</Button></Col>
        </Row>
      </Form>
      <Table
        columns={columns}
        dataSource={dataSource}
        rowKey='sale_id'
        locale={{ emptyText: '未搜索到商品' }}
        rowSelection={rowSelection}
        scroll={{ y: 240, }}
        pagination={{
          pageSize: pageConfig.page_size,
          total: totalPage,
          current: pageConfig.page,
          onChange: tablePageChange
        }} />
      {/* {dataSource?.length ? null : <Empty image={false} description='未搜索到商品' />} */}
    </div>
  );
});